import { getEnv } from "@/env";
import type { DynamicExperienceEnvironment } from "./types";

const PRODUCTION_HOSTNAME = "www.edx.org";

const getHostname = (siteUrl: string): string | undefined => {
  try {
    return new URL(siteUrl).hostname;
  } catch {
    return undefined;
  }
};

/**
 * UCL serves a separate experience catalog per environment, so the deployed
 * host decides which catalog a visitor mounts. Never derive this from a URL
 * param: that would let anyone put the INT experience on production.
 */
export const resolveDynamicExperienceEnvironment =
  (): DynamicExperienceEnvironment =>
    getHostname(getEnv("NEXT_PUBLIC_SITE_URL", "")) === PRODUCTION_HOSTNAME
      ? "prod"
      : "int";
